<template></template>
<script>
import Vue from "vue";
export default {
  name: "websocket",
  data() {
    return {
      ws: null,
      userId: sessionStorage.getItem("userId")
    };
  },
  created() {
    //192.168.1.65/bohee
    //this.ws = new WebSocket("ws://192.168.1.65/bohee/bop/websocket/cl?userId=" + this.userId);
    let wsServer ='ws://' + location.host + '/bohee/bop/websocket/socketlist?userId=' + this.userId;
    this.ws = new WebSocket(wsServer);
    this.ws.onopen = this.onopen;
    this.ws.onclose = this.onclose;
    this.ws.onmessage = this.onmessage;
    this.ws.sendMessage = this.sendMessage;
    Vue.prototype.$ws = this.ws;
  },
  mounted() {},
  methods: {
    onopen() {
    },
    onclose() {
      
    },
    onmessage(res){
      this.$emit("callback",res.data)
    },
    sendMessage(target, content) {
      if (target == undefined || target == null || target.length == 0) {
        
      } else if (content == undefined || content == null || content.length == 0) {
        
      }else{
        if(typeof(target)=="string"){
            this.ws.send(JSON.stringify({ target: target, content: content }));
        }else if( Array.isArray(target)){
          let context="";
          target.forEach(item=>{
            context+=item+","
          })
          context = context.substr(0,context.length-1);
          this.ws.send(JSON.stringify({ target: context, content: content }));
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/websocket/websocket.vue